// Service Auto Distribution 관련 공통 상수
import { IS_PRODUCTION } from './constant';

export const SERVICE_OPTIONS = [
  { name: 'ODKR', apiName: 'odk' },
  { name: 'Amasian', apiName: 'amasian' },
  { name: 'ODC', apiName: 'odc' },
  { name: 'Vietnam LG channel', apiName: 'vietnam-lg-channel' },
];

export const ENVIRONMENTS = ['production', 'staging'] as const;

export const SUBTITLE_LANGUAGES = [
  { value: 'en', label: 'En' },
  { value: 'ko', label: 'Ko' },
  { value: 'zh-hans', label: 'Zh-Hans' },
  { value: 'zh-hant', label: 'Zh-Hant' },
  { value: 'vi', label: 'Vi' },
  { value: 'es', label: 'Spanish(es-419)' },
];

/**
 * API service_name 변환 함수
 * Display name과 environment를 받아서 API에서 사용하는 service_name으로 변환
 */
export const getApiServiceName = (displayName: string): string => {
  const service = SERVICE_OPTIONS.find(s => s.name === displayName);
  if (!service) return displayName;
  return service.apiName;
};

/**
 * 기본 Distribution 초기화
 */
export const createDefaultDistributions = (): any[] => {
  const defaultDistributions: any[] = [];
  SERVICE_OPTIONS.forEach(service => {
    defaultDistributions.push({
      service_name: service.name,
      environment: IS_PRODUCTION ? 'production' : 'staging',
      enabled: false,
      auto_publish: false,
      subtitle_langs: [],
    });
  });
  return defaultDistributions;
};
